<template>
    <div>
        <app-title text="Indicadores de Uso" />
        <b-card no-body>
            <b-tabs card>
                <b-tab title="Por Cliente" active>
                    <app-client-operational-indicators />
                </b-tab>
                <b-tab title="Por Ciudad">
                    <app-city-operational-indicators />
                </b-tab>
                <b-tab title="Exportar datos">
                    <app-export-operational-indicators />
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ClientOperationalIndicators from './ClientOperationalIndicators/ClientOperationalIndicators';
import CityOperationalIndicators from './CityOperationalIndicators/CityOperationalIndicators';
import ExportOperationalIndicators from './ExportOperationalIndicators/ExportOperationalIndicators';
export default {
    name: 'operational_indicators',
    components: {
        appClientOperationalIndicators: ClientOperationalIndicators,
        appCityOperationalIndicators: CityOperationalIndicators,
        appExportOperationalIndicators: ExportOperationalIndicators
    }
}
</script>